import { useEffect, useState } from 'react';

export default <T>(loadingList: T[], limit: number) => {
  /**
   * Current list of items to be loaded
   */
  const [queue, setQueue] = useState<T[]>([]);
  const shouldLoad = (item: T) => queue.includes(item);

  useEffect(() => {
    setQueue((currQueue) => {
      // already loaded (or cleared) items from the loadingList are removed
      // from the queue
      const updatedQueue = currQueue.filter((queueItem) =>
        loadingList.includes(queueItem),
      );

      // Add new items to the queue if there is a room
      for (const item of loadingList) {
        if (updatedQueue.length >= limit) {
          break;
        }

        if (!updatedQueue.includes(item)) {
          updatedQueue.push(item);
        }
      }

      return updatedQueue;
    });
  }, [limit, loadingList]);

  return {
    shouldLoad,
  };
};
